import styled from "styled-components";
import { alignItems, textAlign, padding } from "styled-system";

export const StyledSectionWrapper = styled.div`
  padding-top: 64px;
  & > p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.161738px;
    margin-bottom: 10px;
    color: #96a8be;
    padding: 0 18px;
  }

  & > h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    margin-bottom: 26px;
    color: #233247;
    padding: 0 18px;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    & > h3 {
      margin-bottom: 80px;
    }
  }
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 6% 0 8%;
  background: url("./images/mobile-vms.png");
  background-position: 43% 0;
  background-size: 130%;
  background-repeat: no-repeat;

  & .image-wrapper {
    width: 51%;
    max-width: 200px;
    flex: none;
  }

  & img {
    width: 100%;
    height: auto;
  }

  & .item-wrapper {
    display: flex;
    margin-bottom: 10px;
  }

  & .item-wrapper:last-child {
    flex-direction: row-reverse;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    flex-direction: row;
    background: url("./images/vms-desktop-line.png");
    background-repeat: no-repeat;
    background-position: 0 195px;
    background-size: 100% auto;
    padding-right: 0;
    padding-left: 0;
    border-bottom: 1px solid rgba(58, 79, 106, 0.1);

    & .item-wrapper {
      width: 50%;
      margin-bottom: 80px;
    }

    & .item-wrapper:first-child {
      flex-direction: row-reverse;
      margin-right: 20px;
    }

    & .item-wrapper:last-child {
      flex-direction: row;
      width: 50%;
    }
  }
`;

export const StyledDescription = styled.div`
  display: flex;
  ${padding};
  ${alignItems};
  flex-direction: column;

  & > h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 21.0538px;
    line-height: 21px;
    margin: 19px 0 16px;
    color: #233247;
  }

  & > p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    ${textAlign};
    color: #586981;
  }

  & > span {
    margin-top: 47px;
    width: 40px;
    height: 40px;
    background: #ffffff;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    max-width: 240px;
  }
`;
